"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventually = void 0;
var tslib_1 = require("tslib");
var index_1 = require("../index");
var eventually = function (callback, timeout, retryDelay, errorSet) {
    if (timeout === void 0) { timeout = 3000; }
    if (retryDelay === void 0) { retryDelay = 100; }
    if (errorSet === void 0) { errorSet = new Set(); }
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var message, e_1, now, delta;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (timeout < 0) {
                        message = Array.from(errorSet).reduce(function (previousMessage, currentMessage, idx) { return "".concat(previousMessage, "\n\t\t").concat(idx + 1, ". ").concat(currentMessage); }, '');
                        throw new Error("[Eventually timeout exceeded after: timeout with error]: ".concat(message));
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 5]);
                    return [4 /*yield*/, callback()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    now = Date.now();
                    return [4 /*yield*/, (0, index_1.delay)(retryDelay)];
                case 4:
                    _a.sent();
                    delta = Date.now() - now;
                    errorSet.add(e_1.message);
                    return [2 /*return*/, (0, exports.eventually)(callback, timeout - delta, retryDelay, errorSet)];
                case 5: return [2 /*return*/];
            }
        });
    });
};
exports.eventually = eventually;
//# sourceMappingURL=index.js.map